import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './style.css';
import { fileFromUrl } from '../../libs/url';
import missingImage from '../../../assets/images/missing-image.png';

class ImageUploader extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isDragOver: false,
      isMouseOver: false,
      isSelecting: false,
    };

    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);

    this.onDragOver = this.onDragOver.bind(this);
    this.onDrop = this.onDrop.bind(this);

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.onFileInputChange = this.onFileInputChange.bind(this);
  }

  render() {
    const { image, onImageChange, isDisabled, imageUrls } = this.props;
    const { isMouseOver, isDragOver } = this.state;

    return (
      <div
        // onDrag={ this.cancelEvent }
        // onDragStart={ this.cancelEvent }
        // onDragEnd={ this.cancelEvent }

        onDragEnter={ this.onDragEnter }
        onDragLeave={ this.onDragLeave }

        // Required for this element to be a drag drop zone
        onDragOver={ this.onDragOver }
        onDrop={ this.onDrop }

        onMouseEnter={ this.onMouseEnter }
        onMouseLeave={ this.onMouseLeave }

        draggable={ true }
        className={ classNames({
          [style.preventPointerEventsForChildren]: !isMouseOver,
        }) }
      >
        <section>
          <div className={ style.fileUploadControls} >
            <img
              className={ classNames(style.preview, {
                [style.dimmed]: isMouseOver || isDragOver,
              }) }
              src={ image || missingImage }
            />
            <div className={ classNames(style.selectContainer, {
              [style.hidden] : !(isMouseOver || isDragOver),
            }) }>
              <label
                className={ style.selectLabel }
              >Välj bild eller drag och släpp här
                <input
                  className={ style.fileInput }
                  onChange={ this.onFileInputChange }
                  type="file"
                  accept="image/*"
                  name="image"
                />
              </label>
              <label className={ style.label }>Bild
                <select
                  className={ style.select}
                  value={ decodeURIComponent(image) }
                  onChange={ onImageChange }
                  disabled={ isDisabled }
                >
                  <option disabled={ true } value="">Bild saknas</option>
                  { imageUrls.map((imageUrl, index) => {
                    return (
                      <option
                        key={ index }
                        value={ imageUrl }
                      >{ fileFromUrl(imageUrl) }</option>
                    );
                  })}
                </select>
              </label>
            </div>
          </div>
        </section>
      </div>
    );
  }

  cancelEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragEnter(event) {
    this.cancelEvent(event);
    this.setState({ isDragOver: true });
  }

  onDragLeave() {
    this.cancelEvent(event);
    this.setState({isDragOver: false });
  }

  onDragOver(event) {
    this.cancelEvent(event);
    event.dataTransfer.dropEffect = 'copy';
  }

  onDrop(event) {
    this.cancelEvent(event);
    const [ file ] = event.dataTransfer.files;
    this.selectFile(file);
    this.setState({isDragOver: false });
  }

  onFileInputChange(event) {
    const [ file ] = event.target.files;
    this.selectFile(file);
  }

  selectFile(file) {
    if(!file) {
      return;
    }

    if(!(/^image/).test(file.type)) {
      return;
    }

    const { onFileSelect } = this.props;
    onFileSelect(file);
  }

  onMouseEnter(/*event*/) {
    this.setState({ isMouseOver: true });
  }

  onMouseLeave(/*event*/) {
    this.setState({ isMouseOver: false });
  }

}

ImageUploader.propTypes = {
  image: PropTypes.string,
  onFileSelect: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  imageUrls: PropTypes.array.isRequired,
};

export default ImageUploader;



// WEBPACK FOOTER //
// ./client/src/components/image-uploader/index.js